type Callable = (...args: never[]) => unknown;

export function once<T extends Callable>(func: T): T {
    let called = false;
    let result: ReturnType<T>;
    
    const wrapped = function (this: ThisParameterType<T>, ...args: Parameters<T>): ReturnType<T> {
        if (!called) {
            called = true;
            result = func.apply(this, args) as ReturnType<T>;
        }
        
        return result;
    };
    
    return wrapped as T;
}
